import React from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { WhyFailSection } from './components/WhyFailSection';
import { ProtocolSection } from './components/ProtocolSection';
import { AboutKate } from './components/AboutKate';
import { ServicesMenu } from './components/ServicesMenu';
import { FeaturedTreatments } from './components/FeaturedTreatments';
import { GuaranteeSection } from './components/GuaranteeSection';
import { HoursLocation } from './components/HoursLocation';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { WhatsAppFloat } from './components/WhatsAppFloat';
import { PromoBanner } from './components/PromoBanner';
import { LanguageProvider } from './context/LanguageContext';
import { SEOHead } from './components/SEOHead';
import { IntroCurtain } from './components/IntroCurtain';
import { GiftCardSection } from './components/GiftCardSection';
export function App() {
  return <LanguageProvider data-id="element-0" data-mp="3rc9dg5wfbbwp">
      <SEOHead data-id="element-1" data-mp="3rbzn2h7gv2qh" />
      <IntroCurtain data-id="element-2" data-mp="3rdatkosaqola" />
      <div className="min-h-screen bg-brand-white font-sans text-brand-charcoal selection:bg-brand-gold/30" data-id="element-3" data-mp="3rd1azm9kzjpm">
        <PromoBanner data-id="element-4" data-mp="82kz509bybz" />
        <Header data-id="element-5" data-mp="2zl3c5m4yv85u" />
        <main data-id="element-6" data-mp="2zllduyaeeel5">
          <HeroSection data-id="element-7" data-mp="2zm4ywnvchj3e" />
          <ServicesMenu data-id="element-8" data-mp="2zmo7vf30ox5a" />
          <FeaturedTreatments data-id="element-9" data-mp="2zng2onosiqui" />
          <PainSection data-id="element-10" data-mp="33m5eibu6k0c1" />
          <TestimonialsSection data-id="element-11" data-mp="33nggc642ey0i" />
          <WhyFailSection data-id="element-12" data-mp="33orla998ybt7" />
          <ProtocolSection data-id="element-13" data-mp="38m1f013o59mu" />
          <AboutKate data-id="element-14" data-mp="38kqau06b9zv7" />
          <GuaranteeSection data-id="element-15" data-mp="38kgkucl9nspi" />
          <HoursLocation data-id="element-16" data-mp="3dkuufz2inapn" />
          <FAQSection data-id="element-17" data-mp="3dl4mrtb19tyi" />
          <GiftCardSection data-id="element-18" data-mp="3dlns8ajhypvn" />
          <FinalCTA data-id="element-19" data-mp="3dirw8rr7mb9u" />
        </main>
        <Footer data-id="element-20" data-mp="nw2a60hx7gog" />
        <WhatsAppFloat data-id="element-21" data-mp="nuhged3fk1rn" />
      </div>
    </LanguageProvider>;
}